module.exports = __webpack_public_path__ + "img/img11.428cbd4d.png";